import { Space, SpaceProps } from 'component/Space'
import { ForwardedRef, forwardRef } from 'react'

type Ref = ForwardedRef<HTMLDivElement>

export const Vertical = forwardRef((props: SpaceProps, ref: Ref) => {
  return <Space ref={ref} vertical {...props} />
})
